import { SvgIcon } from '@mui/material';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChangePasswordDialog } from '@/features/changePassword';
import { logout } from '@/entities/session';
import { ROUTES } from '@/shared/constants';
import { useAppDispatch } from '@/shared/model';
import { AvatarIcon, UserSettingsIcon } from '@/shared/ui';
import { BottomItem, BottomMenuItem } from '../BottomItem';

export function ProfileBottomItem() {
  const dispatch = useAppDispatch();
  const [changePasswordDialogOpen, setChangePasswordDialogOpen] =
    useState(false);

  const handleLogout = () => {
    dispatch(logout());
  };

  return (
    <>
      <BottomItem
        icon={
          <AvatarIcon sx={{ width: 28, height: 28, color: 'primary.main' }} />
        }
        label="Profile"
        menuContent={[
          <BottomMenuItem
            key="user-settings"
            icon={<UserSettingsIcon />}
            label="User Settings"
            component={Link}
            to={ROUTES.userSettings}
          />,
          <BottomMenuItem
            key="logout"
            icon={
              <SvgIcon>
                <svg
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.5 17.5H4.16667C3.72464 17.5 3.30072 17.3244 2.98816 17.0118C2.67559 16.6993 2.5 16.2754 2.5 15.8333V4.16667C2.5 3.72464 2.67559 3.30072 2.98816 2.98816C3.30072 2.67559 3.72464 2.5 4.16667 2.5H7.5M13.3333 14.1667L17.5 10M17.5 10L13.3333 5.83333M17.5 10H7.5"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </SvgIcon>
            }
            label="Logout"
            onClick={handleLogout}
          />,
        ]}
      />
      <ChangePasswordDialog
        open={changePasswordDialogOpen}
        onClose={() => setChangePasswordDialogOpen(false)}
      />
    </>
  );
}
